import React from 'react';
import { stringifyUrl } from 'query-string';
import { QueryStringKeys } from '../../../../constants/query-string-keys';
import { UTMContent, UTMMedium, UTMSource, UTMTerm } from '../../../../constants/query-string-values';
import { Routes } from '../../../../constants/routes';
import { PetInsurerWithFeaturedProviders } from '../../../../wag-react/components/pet-insurer-cta-section/components';
export type WellnessPetInsurerWithFeaturedProvidersProps = {
  slug: string;
};
export const WellnessPetInsurerWithFeaturedProviders = ({
  slug
}: WellnessPetInsurerWithFeaturedProvidersProps) => {
  const url = stringifyUrl({
    url: Routes.PetInsuranceQuoteLink,
    query: {
      [QueryStringKeys.UTMCampaign]: slug,
      [QueryStringKeys.UTMContent]: UTMContent.WellnessCareArticle,
      [QueryStringKeys.UTMMedium]: UTMMedium.Web,
      [QueryStringKeys.UTMSource]: UTMSource.Wag,
      [QueryStringKeys.UTMTerm]: UTMTerm.InsuranceContentBlock
    }
  });
  return <PetInsurerWithFeaturedProviders my={['16px', '32px']} ctaLink={url} data-sentry-element="PetInsurerWithFeaturedProviders" data-sentry-component="WellnessPetInsurerWithFeaturedProviders" data-sentry-source-file="index.tsx" />;
};